export default __webpack_public_path__ + "static/ic_logo-94bcf90e0035b2f24c30bd7a73dc0182.svg";